<template>
    <div class="gallery-editor">
        <section class="panel media-container">
            <div class="panel-heading">
                <h2>
                    <i class="fa fa-image"></i>
                    Media
                </h2>
            </div>
            <div class="panel-body">
                <gallery-media-list-editor :disciplines="disciplines" :disabled="submitting" v-model="secondaryMedia">
                </gallery-media-list-editor>
            </div>
        </section>
        <section class="panel thumbnail-container">
            <div class="panel-heading">
                <h2>
                    <i class="fa fa-image"></i>
                    Thumbnail
                </h2>
            </div>
            <div class="panel-body">
                <form @submit.prevent="">
                    <fieldset :disabled="submitting">
                        <div class="form-group">
                            <label class="form-button">
                                <input type="file" @change="setFeaturedMediaFromFile">
                                Upload Image
                            </label>
                        </div>
                        <div v-if="!!featuredMedia.url">
                            <image-cropper ref="imageCropper" :url="featuredMedia.url" :crop="featuredMediaCropPoints">
                            </image-cropper>
                        </div>
                        <div class="empty-area" v-else>
                            <p>No thumbnail to show</p>
                        </div>
                    </fieldset>
                </form>
            </div>
        </section>
        <section class="panel info-container">
            <div class="panel-heading">
                <h2>
                    <i class="fa fa-info-circle"></i>
                    Details
                </h2>
            </div>
            <div class="panel-body">
                <form @submit.prevent="">
                    <fieldset :disabled="submitting">
                        <div class="form-group">
                            <label>
                                <span v-tooltip="'Required'">Title *</span>
                            </label>
                            <input class="form-control" type="text" v-model="title" placeholder='Should be artistic (eg "A Starry Night"), not generic (eg "Final Project")' required>
                        </div>
                        <div class="form-group">
                            <label>Description</label>
                            <textarea class="form-control" v-model="description" placeholder="Tell us anything you like about this project." cols="50" rows="3">
                            </textarea>
                        </div>
                        <div class="form-group categories">
                            <label>Categories</label>
                            <select :class="{'form-control': true, placeholder: !term}" v-model="termId">
                                <option :value="null">
                                    Term
                                </option>
                                <option v-for="term in termOptions" :value="term.id">
                                    {{ term.name }}
                                </option>
                            </select>
                            <select :class="{'form-control': true, placeholder: !path, hidden: isTermFoundation(this.termId)}" v-model="pathId">
                                <option :value="null">
                                    Path
                                </option>
                                <option v-for="path in pathOptions" :value="path.id" v-if="path.id != 9200">
                                    {{ path.name }}
                                </option>
                            </select>
                            <select :class="{'form-control': true, placeholder: !assignment}" v-model="assignmentId">
                                <option :value="null">
                                    Assignment
                                </option>
                                <option v-for="assignment in assignmentOptions" :value="assignment.id">
                                    {{ assignment.name }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Software</label>
                            <software-select :options="gallerySoftware" :canCreate="false" v-model="softwareUsed" :placeholder="'Select all software used in the making of this project.'">
                            </software-select>
                        </div>
                        <div class="form-group tags">
                            <label>Tags</label>
                            <tag-select :search="searchTags" :canCreate="true" v-model="tags" :placeholder="'Short descriptive keywords describing the imagery, eg: sci-fi, warrior, sword, cat, ninja, castle, bird'">
                            </tag-select>
                        </div>
                        <div class="dam-fields">
                            <div class="form-group">
                                <label>Industry Focus</label>
                                <select class="form-control" v-model="industryFocus">
                                    <option v-for="focus in industryFocuses" :key="focus">{{focus}}</option>
                                </select>
                            </div>
                            <div class="form-group final-project">
                                <div>Final Project</div>
                                <label>Yes<input type="radio" v-model="isFinalProject" value="Yes"><span class="toggle"></span></label>
                                <label>No<input type="radio" v-model="isFinalProject" value="No"><span class="toggle"></span></label>
                            </div>
                            <div class="form-group">
                                <label>Creation Date *</label>
                                <datepicker :option="dateOptions" :date="creationDate" v-model="creationDate"></datepicker>
                            </div>
                            <div class="form-group">
                                <label>Your Own Personal Artist Nickname / Alias</label>
                                <input type="text" class="form-control" v-model="moniker" placeholder="If you have an artist moniker you prefer to be credited with instead of your real name, put it here">
                            </div>
                            <div class="form-group">
                                <label>Concept Credit</label>
                                <input type="text" class="form-control" v-model="conceptCredit" placeholder="Please be very sure to provide the correct name and spelling of the concept artist, if applicable">
                            </div>
                            <div class="form-group rookies-submission">
                                <input type="checkbox" v-model="isRookiesSubmission">
                                <label>Tick this box if this project will be submitted to The Rookies</label>
                            </div>
                        </div>
                        <div class="form-group" v-if="canEditHighlight">
                            <label>Recruiter Visbility</label>
                            <div class="form-group recruiters">
                                <label>
                                    <input type="checkbox" v-model="highlighted">
                                    Visible to recruiters
                                </label>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </section>
        <section class="panel submission-container">
            <div class="panel-heading">
                <h2>
                    <i class="fa fa-upload"></i>
                    Submission
                </h2>
            </div>
            <div class="panel-body">
                <form @submit.prevent="submitGallery()">
                    <fieldset :disabled="submitting">
                        <div>
                            <input type="submit" class="btn btn-success" :value="submitText">
                        </div>
                        <div class="submission-feedback" v-if="!!submissionStatus">
                            <div class="submission-status">
                                Status: <em>{{ submissionStatus }}</em>
                            </div>
                            <div class="submission-progress">
                                <div :class="{ 'completed-bar': true, error: !!submissionError }" :style="{ width: (submissionProgress * 100) + '%' }">
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </section>
        <section class="panel delete-container" v-if="!isNewGallery">
            <div class="panel-heading">
                <h2>
                    <i class="fa fa-trash"></i>
                    Delete
                </h2>
            </div>
            <div class="panel-body">
                <form @submit.prevent="deleteGallery()">
                    <fieldset :disabled="deleting">
                        <div class="form-group">
                            <input type="text" class="form-control" placeholder="Type &quot;delete me&quot; to enable the button below" v-model="deletionText">
                        </div>
                        <div>
                            <input type="submit" class="btn btn-danger" value="Delete" :disabled="!canDelete">
                        </div>
                    </fieldset>
                </form>
            </div>
        </section>
    </div>
</template>
<script>
import axios from 'axios';
import toastr from 'toastr';
import UuidV4 from 'uuid/v4';
import moment from 'moment';
import Datepicker from 'vue-datepicker';

import Marmoset from '../packages/marmoset';
import Aws from '../services/aws';
import Galleries from '../services/galleries';
import Noembed from '../services/noembed';
import Sketchfab from '../services/sketchfab';
import ImageCropper from './reusable/image-cropper';
import SoftwareSelect from './reusable/software-select';
import TagSelect from './reusable/tag-select';
import GalleryMediaListEditor from './widgets/GalleryMediaListEditor';
import GallerySoftwareListEditor from './widgets/GallerySoftwareListEditor';
import GalleryTagListEditor from './widgets/GalleryTagListEditor';


function stripMedia(media) {
    return {
        id: media.id,
        type: media.type,
        url: media.url,
        caption: media.caption,
        crop: media.crop,
        disciplines: media.disciplines,
    };
}

export default {
    props: ['id'],

    components: {
        Datepicker,
        ImageCropper,
        SoftwareSelect,
        TagSelect,
        GalleryMediaListEditor,
    },

    data() {
        return {
            // Simple gallery info
            title: '',
            description: null,
            termId: null,
            pathId: null,
            assignmentId: null,
            softwareUsed: [],
            tags: [],
            highlighted: false,
            isFinalProject: 'No',
            creationDate: {
                time: ''
            },
            dateOptions: {
                week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
                month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                placeholder: 'The date of completion of the project',
                format: 'YYYY-MM-DD',
                type: 'day',

            },
            moniker: null,
            conceptCredit: null,
            industryFocus: null,
            isRookiesSubmission: false,
            industryFocuses: ['Film', 'Games', 'TV'],
            discipline: null,
            disciplines: null,
            featuredMedia: {
                id: null,
                type: null,
                url: null,
                crop: null,
                file: null
            },
            secondaryMedia: [],

            // When editing a gallery, we'll store the old version so that
            // we can diff the values at the end.
            oldGallery: null,

            // Search results for category info
            termOptions: [],
            pathOptions: [],
            assignmentOptions: [],

            // The above "options" use this as the source list
            galleryFilters: {
                terms: [],
                paths: [],
                assignments: []
            },

            // The source list of all software
            gallerySoftware: [],

            // When submitting the gallery, we'll want to disable all the
            // forms and show some sort of progress indicator while the
            // media is being uploaded.
            submitting: false,
            submissionStatus: null,
            submissionProgress: 0, // 0 - 1
            submissionError: null,

            deleting: false,
            deletionText: '' // Used for confirmation during the deletion process
        };
    },

    computed: {
        term() {
            return this.termOptions.find(t => t.id == this.termId);
        },

        path() {
            return this.pathOptions.find(p => p.id == this.pathId);
        },

        assignment() {
            return this.assignmentOptions.find(a => {
                return a.id == this.assignmentId;
            });
        },

        featuredMediaCropPoints() {
            if (this.featuredMedia.crop) {
                return {
                    x1: this.featuredMedia.crop.left,
                    y1: this.featuredMedia.crop.top,
                    width: this.featuredMedia.crop.width,
                    height: this.featuredMedia.crop.height,
                };
            }
            return null;
        },

        isNewGallery() {
            return !this.id;
        },

        submitText() {
            if (this.isNewGallery) {
                return this.submitting ? 'Creating...' : 'Create';
            } else {
                return this.submitting ? 'Updating...' : 'Update';
            }
        },

        canDelete() {
            return !this.deleting && this.deletionText === 'delete me';
        },

        userId() {
            return parseInt(localStorage.user_id);
        },

        userRoles() {
            return JSON.parse(localStorage.roles);
        },

        canEditHighlight() {
            return this.userRoles.includes('OnlineDirector');
        },
    },

    async mounted() {

        if (localStorage.path && localStorage.path !== 'null' && localStorage.path != '9200') {
            this.pathId = parseInt(localStorage.path);
            const FILM_PATHS = [6642, 6644];
            const GAME_PATHS = [6627, 6643];
            if (FILM_PATHS.includes(this.pathId)) this.industryFocus = 'Film';
            if (GAME_PATHS.includes(this.pathId)) this.industryFocus = 'Games';
        }


        Galleries.getCloudinaryField('13_discipline').then((response) => {
            this.disciplines = response.values.map(d => d.value);
        });

        await Promise.all([
            this.loadGalleryFilters(),
            this.loadGallerySoftware(),
            this.id ? this.loadGallery() : null,
        ]);


        if (!this.featuredMedia) {
            this.autoSelectFeaturedMedia();
        }

        this.$watch('secondaryMedia', () => {
            if (this.featuredMedia.url) {
                // The featured media is currently set, but it may have been
                // previously auto-selected. If that's the case, we want to
                // see if that media was just removed; if so, pick something
                // new to be the featured media.
                if (this.featuredMedia.autoSelected) {
                    const url = this.featuredMedia.url;
                    const exists = !!this.secondaryMedia.find(m => {
                        return url === m.url || url === m.thumbnailUrl;
                    });
                    if (!exists) {
                        this.autoSelectFeaturedMedia();
                    }
                }
            } else {
                // The featured media hasn't been set, so set it to anything
                // we can.
                this.autoSelectFeaturedMedia();
            }
        });

        this.syncFilterOptions();

        this.$watch('termId', () => {
            this.syncFilterOptions();
            this.makeFiltersValid();
        });
        this.$watch('pathId', () => {
            this.syncFilterOptions();
            this.makeFiltersValid();
        });

        if (this.isNewGallery) {
            this.selectDefaultCategories();
        }
    },

    methods: {
        searchTags: Galleries.searchTags,

        async loadGallery() {
            try {
                const gallery = await Galleries.getGallery(this.id);

                this.oldGallery = JSON.parse(JSON.stringify(gallery));

                this.termId = null;
                this.pathId = null;
                this.assignmentId = null;
                this.title = gallery.title;
                this.description = gallery.description;
                this.softwareUsed = gallery.softwareUsed;
                this.tags = gallery.tags;
                this.highlighted = gallery.highlighted;
                this.featuredMedia = gallery.featuredMedia;
                this.secondaryMedia = gallery.secondaryMedia;
                this.creationDate.time = gallery.creationDate.split('T')[0]

                this.moniker = gallery.moniker;
                this.industryFocus = gallery.industryFocus;
                gallery.isFinalProject === true ? this.isFinalProject = 'Yes' : this.isFinalProject = 'No';
                this.conceptCredit = gallery.conceptCredit;
                this.isRookiesSubmission = gallery.isRookiesSubmission;

                if (gallery.term) {
                    this.termId = gallery.term.id;
                }
                if (gallery.path) {
                    this.pathId = gallery.path.id;
                }
                if (gallery.assignment) {
                    this.assignmentId = gallery.assignment.id;
                }

            } catch (error) {
                toastr.error(`
                        There was an error while loading the gallery.
                        Please try again later.
                    `);
                throw error;
            }
        },

        async loadGalleryFilters() {
            try {
                this.galleryFilters = await Galleries.getFilters();
                console.log(this.galleryFilters)
            } catch (error) {
                toastr.error(`
                        There was an error while loading the filters.
                        Please try again later.
                    `);
                throw error;
            }
        },

        async loadGallerySoftware() {
            try {
                this.gallerySoftware = await Galleries.getAllSoftware();
            } catch (error) {
                toastr.error(`
                        There was an error while loading the software.
                        Please try again later.
                    `);
                throw error;
            }
        },

        syncFilterOptions() {
            const studentTerms = localStorage.terms.split(',');

            this.termOptions = this.galleryFilters.terms
            .filter(t => !t.name.toLowerCase().includes('challenge'))
            .sort((a, b) => {                
                return new Date(b.start_date) - new Date(a.start_date);            
            });
            this.pathOptions = this.galleryFilters.paths;
            this.assignmentOptions = this.galleryFilters.assignments.filter(a => {
                if (this.termId && a.term != this.termId) {
                    return false;
                }
                if (this.pathId && a.path != this.pathId) {
                    return false;
                }

                if (a.term_type === 'foundation') {
                    if (a.path === 9200) {
                        if (localStorage.path == '9200') {
                            return true;
                        } else {
                            return false
                        }
                    } else {
                        if (localStorage.path == '9200') {
                            return false;
                        } else {
                            return true;
                        }
                    }

                }

                return true;
            });

            // Add suffixes to duplicate assignments.
            // If there are mutliple assignments of the same name across
            // different paths, a path suffix is applied (Modeling for
            // File = MF).
            // If there are multiple assignments of the same name within the
            // same path, a number suffix is applied.
            // It is possible for both suffixes to be applied at the same
            // time.
            const genPathSuffix = a => {
                const path = this.galleryFilters.paths.find(p => p.id === a.path);
                return path.name.replace(/([A-Z])[a-z -]*/g, '$1');
            };
            this.assignmentOptions = this.assignmentOptions.map(a => {
                a = Object.assign({}, a);
                a.name = a.name.trim();
                return a;
            });
            this.assignmentOptions.forEach(a1 => {
                if (a1.hasSuffix) {
                    return;
                }
                const dups = this.assignmentOptions.filter(a2 => {
                    return a2.id !== a1.id && a2.name.toLowerCase() === a1.name.toLowerCase();
                });
                if (dups.length > 0) {
                    const dupsByPath = {};
                    [a1, ...dups].forEach(a => {
                        dupsByPath[a.path || '_'] = dupsByPath[a.path || '_'] || [];
                        dupsByPath[a.path || '_'].push(a);
                    });
                    for (const path in dupsByPath) {
                        const dupsBetweenPaths = Object.keys(dupsByPath).length > 1;
                        const usePathSuffix = dupsBetweenPaths && path !== '_';
                        const useNumSuffix = dupsByPath[path].length > 1;
                        for (const [i, a] of dupsByPath[path].entries()) {
                            if (usePathSuffix) {
                                a.name += ' - ' + genPathSuffix(a);
                                a.hasSuffix = true;
                            }
                            if (useNumSuffix) {
                                a.name += ' - ' + (i + 1);
                                a.hasSuffix = true;
                            }
                        }
                    }
                }
            });

            // Sort assignments
            this.assignmentOptions.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();
                return a.localeCompare(b);
            });
        },

        makeFiltersValid() {
            // Be very careful about infinite loops here, as this function
            // is set as a watcher for several filter properties.
            if (this.pathId && this.isTermFoundation(this.termId) && this.pathId !== 9200) {
                this.pathId = null;
            }
            if (this.assignmentId) {
                const optionExists = this.assignmentOptions.find(a => {
                    return a.id == this.assignmentId;
                });
                if (!optionExists) {
                    this.assignmentId = null;
                }
            }
        },

        selectDefaultCategories() {
            if (!this.termId) {
                const ct = this.termOptions.find(t => {
                    return this.isCurrentTerm(t.id);
                });
                if (ct) {
                    this.termId = ct.id;
                }
            }
            if (!this.pathId) {
                const cp = this.pathOptions.find(p => {
                    this.isCurrentPath(p.id);
                });
                if (cp) {
                    this.pathId = cp.id;
                }
            }
        },

        autoSelectFeaturedMedia() {
            if (this.secondaryMedia.length > 0) {
                this.setFeaturedMediaFromMedia(this.secondaryMedia[0]);
            } else {
                this.featuredMedia = {
                    type: null,
                    url: null
                };
            }
            this.featuredMedia.autoSelected = true;
        },

        setFeaturedMediaFromMedia(media) {
            switch (media.type) {
                case 'image':
                    this.featuredMedia = {
                        id: media.id,
                        type: 'image',
                        url: media.url,
                        file: media.file
                    };
                    break;

                case 'video':
                    Noembed.getInfo(media.url).then(info => {
                        this.featuredMedia = {
                            type: 'image',
                            url: info.thumbnailUrl
                        };
                    }, err => {
                        console.log('Error loading video thumbnail for featured media:', err);
                    });
                    break;

                case 'sketchfab':
                    Sketchfab.getInfo(media.url).then(info => {
                        this.featuredMedia = {
                            type: 'image',
                            url: info.thumbnailUrl
                        };
                    }, err => {
                        console.log('Error loading sketchfab thumbnail for featured media:', err);
                    });
                    break;

                case 'marmoset':
                    Marmoset.createThumbnailBlob(media.url).then(blob => {
                        this.featuredMedia = {
                            type: 'image',
                            url: URL.createObjectURL(blob),
                            file: blob,
                        };
                    }, err => {
                        console.log('Error loading marmoset thumbnail for featured media:', err);
                    });
                    break;
            }
        },

        setFeaturedMediaFromFile(ev) {
            if (ev.target.files.length > 0) {
                this.featuredMedia = {
                    type: 'image',
                    url: URL.createObjectURL(ev.target.files[0]),
                    file: ev.target.files[0] // Needed when uploading the file later
                };
            }
        },

        isCurrentTerm(termId) {
            const currentTerm = this.$store.getters.currentTerm;
            if (currentTerm) {
                return termId == currentTerm.id;
            } else {
                return false;
            }
        },

        isCurrentPath(pathId) {
            const currentPathId = localStorage.path;
            if (currentPathId !== 'null') {
                return pathId == currentPathId;
            } else {
                return false;
            }
        },

        isTermFoundation(termId) {
            if (!termId) {
                return false;
            }
            const term = this.termOptions.find(t => t.id === termId);
            return !!term && term.type === 'foundation';
        },

        async submitGallery() {
            // Check required fields


            if (!this.title) {
                toastr.error('Please specify a title.');
                return;
            }

            if (!this.creationDate || !this.creationDate.time || this.creationDate.time.trim() === '') {
                toastr.error('Please specify a creation date');
                return;
            }
            if (this.secondaryMedia.length === 0) {
                toastr.error('You must add at least one image or video.');
                return;
            }
            if (!this.featuredMedia.url) {
                toastr.error('You must specify a thumbnail.');
                return;
            }

            let allAssetsHaveCaptions = true;
            let onlyOneWordCaptions = true;
            let allAssetsHaveEnoughDisciplines = true;

            for (let asset of this.secondaryMedia) {
                if (!asset.caption || asset.caption.trim() === "") {
                    allAssetsHaveCaptions = false;
                }
                if (asset.caption && asset.caption.trim().indexOf(' ') > -1) {
                    onlyOneWordCaptions = false;
                }
                if (asset.disciplines.length < 2) {
                    allAssetsHaveEnoughDisciplines = false;
                }
            }
            if (allAssetsHaveCaptions === false) {
                toastr.error('Please add a caption to all assets');
                return;
            }
            if (onlyOneWordCaptions === false) {
                toastr.error('Please limit captions to a single word, e.g. "closeup", "wide-angle", "gun", "overhead", etc.<br>Use hyphens for multi-word captions.');
                return;
            }
            if (allAssetsHaveEnoughDisciplines === false) {
                toastr.error('Please add at least two disciplines to each asset');
                return;
            }

            let validFileSize = {
                valid: true,
                message: ''
            };

            for (let asset of this.secondaryMedia) {
                if (asset.file) {
                    if (asset.file.type.includes('image')) {
                        if (asset.file.size >= 100000000) {
                            validFileSize.valid = false;
                            validFileSize.message += 'Image(s) Exceed 100mb Limit. ';
                        }
                    } else {
                        if (asset.file.size >= 4000000000) {
                            validFileSize.valid = false;
                            validFileSize.message += 'Media file(s) Exceed 4gb Limit.';
                        }
                    }
                }
            }

            if (validFileSize.valid === false) {
                toastr.error(validFileSize.message);
                return;
            }


            // Kick off the upload by making sure we're not already
            // mid-upload.
            if (this.submitting) {
                return;
            }
            this.submitting = true;
            this.submissionStatus = 'starting';
            this.submissionProgress = 0.01;
            this.submissionError = null;
            this.creationDate = new Date(this.creationDate.time);

            // In order to provide an accurate progress bar, we'll estimate
            // the steps required ahead of time.
            // NOTE: this isn't exactly accurate when editing a gallery.
            // It's probably pretty likely that a user edits a gallery to
            // simply change a text field or re-order some of the media.
            // However, until it's an issue, I think that simply having any
            // progress bar is good enough.
            const submissionStepCount = (
                this.secondaryMedia.length +
                1 + // thumbnail
                1 + // tags
                1 + // software
                1 // other info
            );
            let submissionStep = 0;
            const advanceSubmissionStep = () => {
                submissionStep++;
                const progress = submissionStep / submissionStepCount;
                this.submissionProgress = Math.max(0.01, Math.min(1.0, progress));
            }

            try {
                // Extract the crop points the thumbnail
                const cropPoints = this.$refs.imageCropper.getPoints();
                this.featuredMedia.crop = {
                    left: cropPoints.x1,
                    top: cropPoints.y1,
                    width: cropPoints.width,
                    height: cropPoints.height
                };


                // STEP 1: Upload the new secondary media
                let counter = 1;
                let total = this.secondaryMedia.length;
                this.submissionStatus = `uploading media (${counter}/${total})`;
                await this.uploadNewSecondaryMedia(() => {
                    // This progress callback is called for each one of the seconday media
                    // that gets processed.
                    advanceSubmissionStep();
                    this.submissionStatus = `uploading media (${++counter}/${total})`;
                });

                // STEP 2: Upload the thumbnail
                this.submissionStatus = 'uploading thumbnail';
                await this.uploadNewFeaturedMedia();
                advanceSubmissionStep();

                // STEP 3: Create the new tags
                this.submissionStatus = 'creating tags';
                await this.createNewTags();
                advanceSubmissionStep();

                // STEP 4: Create the new software
                this.submissionStatus = 'creating software';
                await this.createNewSoftware();
                advanceSubmissionStep();

                // STEP 5: Diff and update the gallery
                this.submissionStatus = 'updating gallery';
                let oldGallery = this.oldGallery;
                if (this.isNewGallery) {
                    oldGallery = {
                        title: null,
                        description: null,
                        term: null,
                        path: null,
                        assignment: null,
                        featuredMedia: {},
                        secondaryMedia: [],
                        tags: [],
                        softwareUsed: [],
                        highlighted: false,
                        isFinalProject: null,
                        moniker: null,
                        conceptCredit: null,
                        industryFocus: null,
                        creationDate: null,
                        isRookiesSubmission: false
                    };
                }
                const diff = this.diffGalleries(oldGallery, this);



                if (diff.term) {
                    diff.term = diff.term.id;
                }
                if (diff.path) {
                    diff.path = diff.path.id;
                }
                if (diff.assignment) {
                    diff.assignment = diff.assignment.id;
                }
                if (diff.tags) {
                    diff.tags = diff.tags.map(t => t.id);
                }
                if (diff.softwareUsed) {
                    diff.softwareUsed = diff.softwareUsed.map(s => s.id);
                }

                if (!this.canEditHighlight) {
                    delete diff.highlighted;
                }


                let id = this.id;
                if (this.isNewGallery) {
                    diff.createdBy = this.userId;
                    const newGallery = await Galleries.createGallery(diff);
                    id = newGallery.id;
                } else {

                    diff.moniker = this.moniker;
                    diff.conceptCredit = this.conceptCredit;
                    diff.isRookiesSubmission = this.isRookiesSubmission;
                    await Galleries.updateGallery(id, diff);
                }
                advanceSubmissionStep();
                this.submissionStatus = 'done';

                // Go to the updated gallery
                this.$router.push({
                    name: 'gallery',
                    params: {
                        galleryId: id
                    }
                });
                this.submitting = false;
                this.submissionStatus = null;

            } catch (error) {
                console.log('Error updating gallery:', error);
                toastr.error('There was an error while updating the gallery. Please try again later.');
                this.submitting = false;
                this.submissionError = error || true;
            }
        },

        async uploadNewFeaturedMedia() {
            if (this.featuredMedia.id) {
                return;
            }
            const filename = UuidV4();
            const file = this.featuredMedia.file;
            const url = this.featuredMedia.url;

            if (file) {
                const s3Url = await this.uploadImageToS3(filename, file);

                // Replace the temporary local url with the S3 url
                URL.revokeObjectURL(this.featuredMedia.url);
                this.featuredMedia.url = s3Url;

            } else if (url) {
                // If the featured media has a URL but no file, that means
                // that the URL is from a different domain (YouTube
                // thumbnail, for example). To handle this, we'll download
                // the file (through our server, to deal with CORS), and
                // reupload it to S3.
                const options = {
                    method: 'GET',
                    baseURL: window.apiUrl,
                    url: '/proxy-get',
                    params: { url },
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.token
                    },
                    responseType: 'blob'
                };
                const res = await axios(options);
                const s3Url = await this.uploadImageToS3(filename, res.data);
                this.featuredMedia.url = s3Url;

            } else {
                throw new Error('featured media is in an unknown state');
            }
        },

        async uploadNewSecondaryMedia(progressCb) {
            const promises = this.secondaryMedia.map(async media => {
                if (media.file) {
                    // Upload to S3
                    const filename = UuidV4();
                    const file = media.file;
                    let s3Url;
                    switch (media.type) {
                        case 'image':
                            s3Url = await this.uploadImageToS3(filename, file);
                            break;
                        case 'marmoset':
                            s3Url = await this.uploadMarmosetToS3(filename, file);
                            break;
                        default:
                            throw new Error('unrecognized secondary media file type: ' + media.type);
                    }

                    // Replace the temporary local url with the S3 url
                    URL.revokeObjectURL(media.url);
                    media.url = s3Url;
                }
                await progressCb();
            });
            await Promise.all(promises);
        },

        async createNewTags() {
            const promises = this.tags.map(async tag => {
                // Tags are created server side, so if the tag has an id,
                // then it already exists.
                if (tag.id) {
                    return;
                }

                // Sometimes the server isn't checked by the tag editor -
                // particularly when the user types a tag and hits Enter
                // before the search can return. To prevent creating
                // duplicates in such a scenario, we'll double check with
                // the server.
                // TODO: Ideally, we'd use a server route that upserts the
                // tag, to prevent race conditions.
                const results = await Galleries.searchTags(tag.name);
                for (const existingTag of results) {
                    if (tag.name.toLowerCase() === existingTag.name.toLowerCase()) {
                        tag.id = existingTag.id;
                        return;
                    }
                }

                // Create the tag
                const newTag = await Galleries.createTag({
                    name: tag.name
                });
                tag.id = newTag.id;
            });
            await Promise.all(promises);
        },

        async createNewSoftware() {
            const promises = this.softwareUsed.map(async software => {
                if (software.id) {
                    return;
                }
                const newSoftware = await Galleries.createSoftware({
                    name: software.name
                });
                software.id = newSoftware.id;
            });
            await Promise.all(promises);
        },

        /**
         * Returns the fields that have changed from g1 to g2. Input tags
         * can be either an array of ids or an array of objects with ids;
         * only the ids are checked when diffing. Same with input software.
         */
        diffGalleries(g1, g2) {
            const diffSimpleFields = (g1, g2) => {
                const diff = {};
                const fields = [
                    'title',
                    'description',
                    'highlighted',
                    'moniker',
                    'creationDate',
                    'isFinalProject',
                    'industryFocus',
                    'conceptCredit',
                    'isRookiesSubmission'
                ];
                fields.forEach(field => {
                    if (g1[field] !== g2[field]) {
                        diff[field] = g2[field];
                    }
                });
                return diff;
            };

            const diffCategories = (g1, g2) => {
                // Categories, while relatively simple, require slightly
                // different logic than the "simple" fields above.
                const diff = {};

                const termId1 = g1.term && g1.term.id;
                const termId2 = g2.term && g2.term.id;
                if (termId1 !== termId2) {
                    diff.term = g2.term || null;
                }

                const pathId1 = g1.path && g1.path.id;
                const pathId2 = g2.path && g2.path.id;
                if (pathId1 !== pathId2) {
                    diff.path = g2.path || null;
                }

                const assignmentId1 = g1.assignment && g1.assignment.id;
                const assignmentId2 = g2.assignment && g2.assignment.id;
                if (assignmentId1 !== assignmentId2) {
                    diff.assignment = g2.assignment || null;
                }

                return diff;
            };

            const diffFeaturedMedia = (g1, g2) => {
                const obj1 = stripMedia(g1.featuredMedia);
                const obj2 = stripMedia(g2.featuredMedia);
                if (JSON.stringify(obj1) !== JSON.stringify(obj2)) {
                    return {
                        featuredMedia: g2.featuredMedia
                    };
                }
            };

            const diffSecondaryMedia = (g1, g2) => {
                const obj1 = g1.secondaryMedia.map(stripMedia);
                const obj2 = g2.secondaryMedia.map(stripMedia);
                if (JSON.stringify(obj1) !== JSON.stringify(obj2)) {
                    return {
                        secondaryMedia: g2.secondaryMedia
                    };
                }
            };

            const diffSoftware = (g1, g2) => {
                if (g1.softwareUsed.length !== g2.softwareUsed.length) {
                    return {
                        softwareUsed: g2.softwareUsed
                    };
                }
                for (let i = 0; i < g2.softwareUsed.length; ++i) {
                    const s1 = g1.softwareUsed[i];
                    const s2 = g2.softwareUsed[i];
                    if ((s1.id || s1) !== (s2.id || s2)) {
                        return {
                            softwareUsed: g2.softwareUsed
                        };
                    }
                }
            };

            const diffTags = (g1, g2) => {
                if (g1.tags.length !== g2.tags.length) {
                    return {
                        tags: g2.tags
                    };
                }
                for (let i = 0; i < g2.tags.length; ++i) {
                    const t1 = g1.tags[i];
                    const t2 = g2.tags[i];
                    if ((t1.id || t1) !== (t2.id || t2)) {
                        return {
                            tags: g2.tags
                        };
                    }
                }
            };

            return Object.assign({},
                diffSimpleFields(g1, g2),
                diffCategories(g1, g2),
                diffFeaturedMedia(g1, g2),
                diffSecondaryMedia(g1, g2),
                diffSoftware(g1, g2),
                diffTags(g1, g2),
            );
        },

        /**
         * @async
         * @param {string}        bucket
         * @param {string}        filename
         * @param {HtmlFile|Blob} fileOrData
         * @param {object}        [options]
         * @param {string}        [options.contentDisposition]
         * @returns {string} url
         */
        async uploadFileToS3(bucket, filename, fileOrData, options = {}) {
            const signature = await Aws.signature(
                fileOrData,
                filename,
                bucket,
                options.contentDisposition,
            );
            const presignedUrl = await Aws.getPresignedUrl(
                this,
                bucket,
                filename,
                'putObject',
            );
            const res = await Aws.upload(
                fileOrData,
                filename,
                signature,
                bucket,
                presignedUrl.data,
                options.contentDisposition,
            );
            return res.url;
        },

        async uploadImageToS3(filename, fileOrData) {
            const bucket = 'ttto-gallery-images-full';
            const contentDisposition = 'attachment';
            return await this.uploadFileToS3(
                bucket,
                filename,
                fileOrData, { contentDisposition },
            );
        },

        async uploadMarmosetToS3(filename, fileOrData) {
            const bucket = 'ttto-gallery-marmosets-full';
            return await this.uploadFileToS3(bucket, filename, fileOrData);
        },

        async deleteGallery() {
            if (!this.canDelete) {
                return;
            }
            try {
                this.deleting = true;
                await Galleries.deleteGallery(this.id);
                this.$router.push({ name: 'galleries' });

            } catch (error) {
                console.log('Error deleting gallery:', error);
                toastr.error('There was an error while deleting the gallery. Please try again later.');

            } finally {
                this.deleting = false;
            }
        },
    },
}

</script>
<style lang="scss" scoped>
.rookies-submission {
    display: flex;
    align-items: center;

    input {
        margin: 0;
        margin-right: .5rem;
        cursor: pointer;
    }

}

.final-project {
    label {
        display: flex;
        cursor: pointer;
        flex-direction: row-reverse;
        justify-content: flex-end;
    }

    .toggle {
        border: 1px solid #3cf;
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        position: relative;
        top: 2px;
        margin-right: 8px;
    }

    input {
        display: none;
    }

    input:checked+.toggle {
        background: #3cf;
    }
}

.panel {
    background-color: #222222 !important;
}

.panel-heading i {
    color: #33ccff;
    padding-right: 7px;
}

.form-button {
    background: #33ccff;
    border: #33ccff solid 1px;
    border-radius: 0;
    box-shadow: none;
    box-sizing: border-box;
    color: black;
    display: inline-block;
    font-weight: 400 !important;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    text-decoration: none;
    text-shadow: none;
    top: 0; // For when using labels to wrap hidden file inputs

    &:hover {
        background: black;
        color: white;
        border: solid 1px #33ccff;
        outline-offset: 0;
    }
}

.empty-area {
    display: table;
    height: 100px;
    width: 100%;
    text-align: center;
    position: relative;

    >p {
        display: table-cell;
        font-style: italic;
        vertical-align: middle;
    }
}

input[type=file] {
    display: none;
}

form {
    margin: 20px;
}

.form-group {
    margin-bottom: 30px;
}

.media-container {
    .panel-body {
        padding: 20px;
    }
}

.thumbnail-container {
    .image-cropper {
        margin: 20px auto;
        max-width: 600px;
    }
}

.info-container {
    .categories {
        label {
            display: block;
        }

        select {
            display: inline-block;
            width: 32%;
            margin-right: 1.4%;
        }

        select:last-child {
            margin-right: 0;
        }

        select.placeholder {
            color: #b0b0b0;
        }
    }

    .recruiters {
        margin-top: 6px;

        input {
            width: 16px;
            height: 16px;
            position: relative;
            top: 2px;
            margin-right: 4px;
        }
    }

    .form-group:last-child {
        margin-bottom: 10px;
    }
}

.submission-container {
    .submission-feedback {
        margin-top: 20px;

        .submission-status em {
            color: #eaeaea;
            font-style: normal;
        }

        .submission-progress {
            background-color: #363636;
            height: 10px;
            border-radius: 5px;
            margin: 15px 0 10px 0;

            .completed-bar {
                background-color: #33ccff;
                border-radius: inherit;
                height: inherit;
            }

            .completed-bar.error {
                background-color: #cc0000;
            }
        }
    }
}

</style>
<style lang="scss">
.gallery-editor {

    .image-cropper {
        .image-container::before {
            content: '';
            display: inline-block;
            padding-top: 100%;
        }
    }

    .software-select {
        .software-list {
            margin-top: 20px;

            >li {
                width: 100px;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// GalleryEditor.vue?aba24360